import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import { injectIntl } from 'react-intl';
import { useQueryClient } from 'react-query';

const AdminFeatureRow = ({ feature, intl }) => {
  const queryClient = useQueryClient();

  function deleteFeature() {
    const confirmMessage = intl.formatMessage({ id: 'feature.view.delete.confirm' });

    if (window.confirm(confirmMessage)) {
      apiCalls
        .deleteFeature(feature.id)
        .then(() => {
          queryClient.invalidateQueries('features');
        })
        .catch((errors) => {
          window.alert(utils.getErrorMessageFromResponse(errors, true));
        });
    }
  }

  return (
    <tr>
      <th scope="row">
        <Link to={`/admin/features/${feature.id}`} className="link">
          {feature.id}
        </Link>
      </th>
      <td>{feature.name}</td>
      <td>{feature.enabled ? 'Enabled' : 'Disabled'}</td>
      <td>
        <Link to={`/admin/features/edit/${feature.id}`} className="link">
          Edit
        </Link>
        <br />
        <button className="btn btn-normal-link" onClick={deleteFeature}>
          Delete
        </button>
        <br />
      </td>
    </tr>
  );
};

AdminFeatureRow.propTypes = {
  feature: PropTypes.object.isRequired,
  getFeatures: PropTypes.func.isRequired,
};

AdminFeatureRow.defaultProps = {};

export default injectIntl(AdminFeatureRow);
